import { render, staticRenderFns } from "./CompetitionMentionsOverTime.vue?vue&type=template&id=2a1a92f5"
import script from "./CompetitionMentionsOverTime.vue?vue&type=script&lang=js"
export * from "./CompetitionMentionsOverTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports